module.exports = __webpack_public_path__ + "images/icons_v2/distributor-d5d3d060.svg";